"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleButton = void 0;
var static_values_1 = require("../../../src/core/static-values");
function toggleButton(utils) {
    var loadPrimaryInput = utils.loadPrimaryInput, hasReturnVal = utils.hasReturnVal, use = utils.use, cySelectSegment = utils.cySelectSegment, cyInput = utils.cyInput, IDs = utils.IDs;
    var _a = static_values_1.staticValues.defaultValue, cpuValue = _a.cpuValue, inputValue = _a.inputValue;
    var clickToggleButton = function (segment) { return function () { return cy.get("#".concat(IDs.buttonIDs.togglePolyfillID)).click().wait(10).then(function () { return cySelectSegment(segment); }); }; };
    /** Time inputs can't be automated other than through direct input like this :( */
    var setNonPolyTime = function (newTime) { return function () { return cyInput().type(newTime); }; };
    describe('Button - Toggle polyfill', function () {
        testToggleWorks();
        testToggleUp();
        testToggleDown();
        function testToggleWorks() {
            it('can toggle on and off', function () {
                loadPrimaryInput()
                    .should('have.value', inputValue)
                    .then(hasReturnVal(cpuValue))
                    .then(clickToggleButton('hrs12'))
                    .should('have.value', '20:30')
                    .then(hasReturnVal('20:30'))
                    .then(clickToggleButton('hrs12'))
                    .should('have.value', '08:30 PM');
            });
        }
        function testToggleUp() {
            describe('up > toggle > up', function () {
                testHrs();
                testMinutes();
                testMode();
                function testHrs() {
                    it('hrs: up > toggle > up > toggle > up', function () {
                        loadPrimaryInput({ segment: 'hrs12' })
                            .then(use.upArrow)
                            .should('have.value', '09:30 PM')
                            .then(hasReturnVal('21:30'))
                            .then(clickToggleButton('hrs12'))
                            .should('have.value', '21:30')
                            .then(setNonPolyTime('22:30'))
                            .should('have.value', '22:30')
                            .then(hasReturnVal('22:30'))
                            .then(clickToggleButton('hrs12'))
                            .should('have.value', '10:30 PM')
                            .then(hasReturnVal('22:30'))
                            .then(use.upArrow)
                            .should('have.value', '11:30 PM')
                            .then(hasReturnVal('23:30'));
                    });
                }
                function testMinutes() {
                    it('minutes: up > toggle > up > toggle > up', function () {
                        loadPrimaryInput({ segment: 'minutes' })
                            .then(use.upArrow)
                            .should('have.value', '08:31 PM')
                            .then(hasReturnVal('20:31'))
                            .then(clickToggleButton('minutes'))
                            .should('have.value', '20:31')
                            .then(setNonPolyTime('20:32'))
                            .should('have.value', '20:32')
                            .then(hasReturnVal('20:32'))
                            .then(clickToggleButton('minutes'))
                            .should('have.value', '08:32 PM')
                            .then(use.upArrow)
                            .should('have.value', '08:33 PM')
                            .then(hasReturnVal('20:33'));
                    });
                }
                function testMode() {
                    it('mode: up > toggle > up > toggle > up', function () {
                        loadPrimaryInput({ segment: 'mode' })
                            .then(use.upArrow)
                            .should('have.value', '08:30 AM')
                            .then(hasReturnVal('08:30'))
                            .then(clickToggleButton('mode'))
                            .should('have.value', '08:30')
                            .then(setNonPolyTime('20:30'))
                            .then(hasReturnVal('20:30'))
                            .then(clickToggleButton('mode'))
                            .should('have.value', '08:30 PM')
                            .then(hasReturnVal('20:30'))
                            .then(use.upArrow)
                            .should('have.value', '08:30 AM')
                            .then(hasReturnVal('08:30'));
                    });
                }
            });
        }
        function testToggleDown() {
            describe('down > toggle > down', function () {
                testHrs();
                testMinutes();
                testMode();
                function testHrs() {
                    it('hrs: down > toggle > down > toggle > down', function () {
                        loadPrimaryInput({ segment: 'hrs12' })
                            .then(use.downArrow)
                            .should('have.value', '07:30 PM')
                            .then(hasReturnVal('19:30'))
                            .then(clickToggleButton('hrs12'))
                            .should('have.value', '19:30')
                            .then(hasReturnVal('19:30'))
                            .then(setNonPolyTime('18:30'))
                            .should('have.value', '18:30')
                            .then(hasReturnVal('18:30'))
                            .then(clickToggleButton('hrs12'))
                            .should('have.value', '06:30 PM')
                            .then(hasReturnVal('18:30'))
                            .then(use.downArrow)
                            .should('have.value', '05:30 PM')
                            .then(hasReturnVal('17:30'));
                    });
                }
                function testMinutes() {
                    it('minutes: down > toggle > down > toggle > down', function () {
                        loadPrimaryInput({ segment: 'minutes' })
                            .then(use.downArrow)
                            .should('have.value', '08:29 PM')
                            .then(hasReturnVal('20:29'))
                            .then(clickToggleButton('minutes'))
                            .should('have.value', '20:29')
                            .then(hasReturnVal('20:29'))
                            .then(setNonPolyTime('20:28'))
                            .should('have.value', '20:28')
                            .then(hasReturnVal('20:28'))
                            .then(clickToggleButton('minutes'))
                            .should('have.value', '08:28 PM')
                            .then(hasReturnVal('20:28'))
                            .then(use.downArrow)
                            .should('have.value', '08:27 PM')
                            .then(hasReturnVal('20:27'));
                    });
                }
                function testMode() {
                    it('mode: down > toggle > down > toggle > down', function () {
                        loadPrimaryInput({ segment: 'mode' })
                            .then(use.downArrow)
                            .should('have.value', '08:30 AM')
                            .then(hasReturnVal('08:30'))
                            .then(clickToggleButton('mode'))
                            .should('have.value', '08:30')
                            .then(hasReturnVal('08:30'))
                            .then(setNonPolyTime('20:30'))
                            .then(clickToggleButton('mode'))
                            .should('have.value', '08:30 PM')
                            .then(hasReturnVal('20:30'))
                            .then(use.downArrow)
                            .should('have.value', '08:30 AM')
                            .then(hasReturnVal('08:30'));
                    });
                }
            });
        }
    });
}
exports.toggleButton = toggleButton;
